import React from 'react';

import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';

import { commonColors } from '../../../commonColors';

import './DisplayModeButton.css';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    height: '25px',
    width: '150px',
  },
  toggleButton: {
    fontFamily: 'Barlow, sans-serif',
    height: '25px',
    width: '75px',
    textTransform: 'capitalize',
    '&.MuiToggleButton-root.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: commonColors.white,
    },
    '&.MuiToggleButton-root.Mui-selected:hover': {
      color: commonColors.white,
    },
  },
}));

export const DisplayModeButton: React.FC<{
  buttonValue?: string;
  value1?: string;
  value2?: string;
  buttonToggled?: (event: React.MouseEvent<HTMLElement>, newValue: string | null) => void;
}> = (props) => {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      value={props.buttonValue}
      exclusive
      onChange={props.buttonToggled}
      aria-label="Toggle button"
      className={classes.buttonContainer}
    >
      <ToggleButton value={props.value1} className={classes.toggleButton}>
        {props.value1}
      </ToggleButton>
      <ToggleButton value={props.value2} className={classes.toggleButton}>
        {props.value2}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
